export const SNEAK_PEEK_VIDEO_PATH = '/media/yan-vada-sneak-peek.mp4'
export const SNEAK_PEEK_VIDEO_URL = `${SNEAK_PEEK_VIDEO_PATH}?v=20260609-2`

